export const ROW_ACTION_GROUPS = {
  BASIC: 0,
  MULTI_LANG: 1,
  STATE_ACTIONS: 2
};
export const VIEW_NAME_ID = {
  ALL_ARTICLES: 'all',
  ALL_DRAFTS: 'drafts',
  ALL_PUBLISHED: 'published',
  ALL_ARCHIVED: 'archived'
};
export const FILTER_CONFIG_PROPERTIES = {
  CATEGORY_ID: 'hs_knowledge_category_id',
  SUBCATEGORY_ID: 'hs_knowledge_subcategory_id'
};